import AppHeader from "@/components/AppHeader";

export default {
  name: "master-car-new",
  components: {
    AppHeader
  },
  async created() {
    this.car.company_id = localStorage.company_id;
    this.getCompany();
    this.getDepartment();
  },
  data() {
    return {
      car: {
        company_id: "",
        department_id: "",
        priority: "",
        name: "",
        car_number: "",
        is_forward_hide: 0
      },
      companies: "",
      getCompaniesEnd: false,
      getDepartmentsEnd: false,
      savingFlag: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async getDepartment() {
      this.getDepartmentsEnd = false;
      let data = {
        company_id: this.car.company_id
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentsEnd = true;
    },
    async createCar() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let data = this.car;
      let res = await this.$store
        .dispatch("CREATE_CAR", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_car" });
      }
    },
    changeCompany() {
      this.car.deparment_id = "";
      this.getDepartment();
    },
    goMasterCar() {
      this.$router.push({ path: "/master_car" });
    }
  }
};
